/**
 * EmptyState — primitive for "nothing here yet" screens.
 * Optional glyph · title · body copy · optional CTA button.
 */

import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  title: string;
  body?: string;
  glyph?: ReactNode;
  ctaLabel?: string;
  onCta?: () => void;
  'data-testid'?: string;
}

export function EmptyState({
  title,
  body,
  glyph,
  ctaLabel,
  onCta,
  'data-testid': testId,
}: EmptyStateProps): JSX.Element {
  return (
    <div className={styles.root} data-testid={testId} role="status">
      {glyph !== undefined && (
        <span className={styles.glyph} aria-hidden="true">
          {glyph}
        </span>
      )}
      <h2 className={styles.title}>{title}</h2>
      {body && <p className={styles.body}>{body}</p>}
      {ctaLabel && onCta && (
        <button
          type="button"
          className={styles.cta}
          onClick={onCta}
          data-testid="empty-state-cta"
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
